<template>
  <div :class="['product-item-wrap', product.className, product.disabled ? 'disabled' : '', checked ? 'active' : '' ]">
    <div
      class="product-item dis-table"
      :cabinLevel="defaultService.cabinLevel"
    >
      <!-- <div class="product-item__segment dis-cell" v-if="isLC">
        <div class="orgdst" >
          {{ itinerary.orgDsts[index].departureAirPortName }}{{ itinerary.orgDsts[index].departureTerminal }} -
          {{ itinerary.orgDsts[index].arrivalAirPortName }}{{ itinerary.orgDsts[index].arrivalTerminal }}
        </div>
      </div> -->

      <div class="product-item__name dis-cell clearfix">
        <div class="flex-hl-vc">
          <span class="productName">
            {{ defaultService.prodCabinName }}
            <a-popover v-if="defaultService.brandDesc">
              <template slot="content">
                <p style="max-width: 300px">
                  {{ defaultService.brandDesc }}
                </p>
              </template>
              <l8-icon type="icon-jinggaoicon" style="vertical-align: super"></l8-icon>
            </a-popover>
          </span>
        </div>
        <!-- <div class="description" v-if="defaultService.brandDesc"><l8-icon type="icon-jinggaoicon"></l8-icon>{{ defaultService.brandDesc }}</div> -->
      </div>

      <div class="product-item__rule dis-cell rules-cell">
        <template v-if="isLC && !ifInternational?.()">
          <div v-for="(serviceItem, serviceIndex) in services" :key="serviceItem.serviceId" class="trip-ct-item flex-hl-vc">
            <span class="trip-ct-label flex-hc-vc">{{ serviceIndex + 1 }}程</span>
            <div class="trip-ct-cabin">
              <span class="cabin">{{ serviceItem.cabinCode || '-' }}<span>舱</span></span>
            </div>
            <rule-list :service="serviceItem" :isJJC="isJJC" class="trip-ct-benefit"></rule-list>
          </div>
        </template>
        <div v-else-if="ifInternational?.()" class="flex-hl-vc">
          <div v-for="(serviceItem) in services" :key="serviceItem.serviceId" class="flex-hl-vc">
            <span class="cabin">{{ serviceItem.cabinCode || '-' }}<span>舱</span></span>
          </div>
          <rule-list :service="intMainService" :isJJC="isJJC" ></rule-list>
        </div >
        <div v-else class="flex-hl-vc">
          <span class="cabin">{{ defaultService.cabinCode || '-' }}<span>舱</span></span>
          <rule-list :service="defaultService" :isJJC="isJJC" ></rule-list>
        </div>
      </div>
      <div class="product-item__placeholder dis-cell">
        <span class="tag" v-if="prices.length === 1">{{ defaultService | priceTag(labelPrices, 'name') }}</span>
        <p class="info"> {{ defaultService | priceTag(labelPrices, 'info') }} </p>
      </div>
      <div class="product-item__price dis-cell flex-hr-vc">
        <span class="price normal-price flex-hc-vc flex-v">
          <template v-if="ifInternational?.()">
            <template v-if="airline === '8L'">
              <span class="dis-price-small" v-if="isRoundTrip?.()">往返 ￥ <span class="dis-price-normal">{{ defaultService.defaultFareIncludeTax }} </span>起</span>
              <span class="dis-price-small" v-else>￥<span class="dis-price-normal">{{ defaultService.defaultFareIncludeTax }} </span></span>
              <p class="tax dis-price-small" >全程含税总价</p>
            </template>
            <template v-else>
              <span class="dis-price-small" v-if="isRoundTrip?.()">往返 ￥ <span class="dis-price-normal">{{ defaultService.defaultFare.amount }} </span>起</span>
              <span class="dis-price-small" v-else>￥<span class="dis-price-normal">{{ defaultService.defaultFare.amount }} </span></span>
              <p class="tax dis-price-small" >全程税 ￥ {{ defaultService.defaultTax }}</p>
            </template>
          </template>
          <template v-else>
            <span class="dis-price-small" >￥<span class="dis-price-normal">{{ defaultService.defaultFare.amount }} </span></span>
          </template>
          <span class="discount dis-price-small" v-if="defaultService.defaultFare?.discount && !isLC">{{ defaultService.defaultFare.discount | discount }}</span>
        </span>
      </div>
      <div class="product-item__action dis-cell">
        <div class="dis-button ">
          <a-button class="product-item-btn product-item-btn--red" v-if="prices.length === 1" @click="onSelectDeafultPrice(defaultService, 0)">立即预订</a-button>
          <a-button class="product-item-btn product-item-btn--yellow" v-if="prices.length > 1 && isShowPrice === false" @click="onShowPrice(defaultService)">立即选购</a-button>
          <a-button class="product-item-btn product-item-btn--yellow" v-if="prices.length > 1  && isShowPrice === true"  @click="onHidePrice()">收起</a-button>
        </div>
        <div class="quantity" v-if="!isLC">
          <span v-if="inventoryService.inventory"> {{ inventoryService.inventory | getInventory }} </span>
        </div>
      </div>
    </div>
    <template v-if="isShowPrice">
      <template v-for="(price,priceIndex) in prices">
        <price
          v-show="!price.isHide"
          @select="onSelectPrice"
          :key="price.code"
          :price="price"
          :labelPrices="labelPrices"
          :priceIndex="priceIndex"
          :index="index"
          :product="product"
          :itinerary="itinerary"
          :isJJC="isJJC"
          :isLC="isLC"
          :segment="segment"
          :isLast="priceIndex === prices.length - 1">
        </price>
      </template>
    </template>
  </div>
</template>

<script>
import '../css/product.less'
import Price from './Price'
import Rule from './Rule'
import { passengerTypeLanguageMap } from '../config'
import { get, minBy } from 'lodash'

const { airline } = window.__MICRO_ROOT__

export default {
  components: {
    Price,
    'rule-list': Rule
  },
  props: {
    itinerary: Object,
    prices: Array,
    product: Object,
    labelPrices: Array,
    segment: Object,
    index: Number,
    checked: Boolean,
    isJJC: Boolean,
    isLC: Boolean
  },
  data () {
    return {
      isShowPrice: false,
      airline,
      passengerTypeLanguageMap: passengerTypeLanguageMap
    }
  },
  inject: {
    ifInternational: {
      value: 'ifInternational',
      default: null
    },
    isRoundTrip: {
      value: 'isRoundTrip',
      default: null
    }
  },
  computed: {
    // 默认航段
    defaultService () {
      const { product } = this
      return product.detail?.services[0]
    },
    // 判断主航段
    intMainService () {
      const { product, itinerary, defaultService } = this
      const ifInternational = this.ifInternational?.()
      const index = itinerary.orgDsts?.findIndex(item => item.isMainSegment)
      const intMainSegment = index !== -1 ? product.detail?.services?.[index] : null
      const intMainService = (ifInternational && intMainSegment) ? intMainSegment : defaultService
      return intMainService
    },
    // 判断余票（最低余票）所在航段
    inventoryService () {
      const { product, defaultService } = this
      const inventoryService = minBy(product.detail?.services, 'inventory')
      return inventoryService || defaultService
    },
    services () {
      const { product } = this
      return product.detail?.services
    }
  },
  methods: {
    onHidePrice () {
      this.isShowPrice = false
    },
    onShowPrice () {
      this.isShowPrice = true
    },

    onRulesChange (index, idx, res) {
      this.$emit('rulesChange', index, idx, res)
    },
    // 仅有一个价格的情况
    onSelectDeafultPrice (service) {
      const { product } = this
      const fare = get(service, 'fareDetails[0].fares[0]')
      this.onSelectPrice(product, fare)
    },
    onSelectPrice (product = {}, fare) {
      const { itinerary } = this
      const { detail, detail: { services } } = product
      const offerServices = services.map(service => {
        return {
          offerServiceId: service.serviceId
        }
      })
      this.$emit('select', product, {
        type: itinerary.itineraryType,
        airlineCode: itinerary.orgDsts[0].airlineCode,
        depCode: itinerary.orgDsts[0].departureCode,
        arrCode: itinerary.orgDsts[itinerary.orgDsts.length - 1].arrivalCode,
        depTime: itinerary.orgDsts[0].departureDate,
        departureDate: itinerary.orgDsts[0].departureDate,
        departureTime: itinerary.orgDsts[0].departureTime,
        arrivalDate: itinerary.orgDsts[itinerary.orgDsts.length - 1].arrivalDate,
        arrivalTime: itinerary.orgDsts[itinerary.orgDsts.length - 1].arrivalTime,
        offerItemIds: [
          {
            code: fare.code,
            offerItemId: detail.offerItemId,
            groupOfferItemIdList: detail.groupOfferItemIdList,
            offerServices
          }
        ],
        flightNo: itinerary.orgDsts[0].flightNo
      })
    }
  }
}
</script>
<style lang="less">
.rules-cell{
  .rules-cell-right {
    width: 25%;
    .rule-item {
      width: 100%;
    }
  }
  .rules-cell-left {
    width: 100%;
    .rule-item {
      width: 50%
    }
  }
  .rule-item {
    min-height: 40px;
    line-height: 40px;
    display: inline-block;
    transition: .2s ease-in;
    color: #333;
    &.hover-effect span{
      border-bottom: 2px solid #ccc;
      padding-bottom: 3px;
    }
    &:not(.hover-effect) {
      cursor: text;
    }
    &.hover-effect:hover {
      opacity: .7;
    }
    .anticon {
      margin-right: 5px;
    }
  }
}

.change-popover {
  .anticon svg {
    fill: #8496a9;
    font-size: 16px;
  }
}

.ant-spin-spinning{
  width: 100%;
  min-height: 40px;
  margin: 10px 0;
}
</style>
